// #region Auth
export const JUGL_LOGIN = "JUGL__LOGIN";
export const JUGL_LAST_LOGIN_METHOD = "JUGL__LAST_LOGIN_METHOD";
export const MOBILE_DEBUG_ACCESS_TOKEN_KEY = "JUGL__MOBILE_DEBUG_ACCESS_TOKEN";
export const MOBILE_DEBUG_ENTITY_ID_KEY = "JUGL__MOBILE_DEBUG_ENTITY_ID";
export const MOBILE_DEBUG_LANGUAGE_KEY = "JUGL__MOBILE_DEBUG_LANGUAGE";
export const MOBILE_DEBUG_ROLE_KEY = "JUGL__MOBILE_DEBUG_ROLE";
export const MOBILE_DEBUG_TIMEZONE_KEY = "JUGL__MOBILE_DEBUG_TIMEZONE";
export const MOBILE_DEBUG_SETUP_AUTH_KEY = "JUGL__MOBILE_DEBUG_SETUP_AUTH";
export const MOBILE_DEBUG_APP_URL_KEY = "JUGL__MOBILE_DEBUG_APP_URL";
// #endregion

// #region Misc keys
export const PERSONALISED_MENU_POPUP_SHOWN =
  "JUGL__PERSONALISED_MENU_POPUP_SHOWN";
export const TIMEZONE_MISMATCH_ALERT_SHOWN =
  "JUGL__TIMEZONE_MISMATCH_ALERT_SHOWN";
export const TIMEZONE_INFO_POPUP_SHOWN = "JUGL__TIMEZONE_INFO_POPUP_SHOWN";
export const SIDEBAR_EXPANDED_KEY = "JUGL__SIDEBAR_EXPANDED";
export const SIDEBAR_MANUAL_WIDTH = "JUGL__SIDEBAR_MANUAL_WIDTH";
export const PAYMENTS_YEARLY_BENEFITS_SHOWN =
  "JUGL__PAYMENTS_YEARLY_BENEFITS_SHOWN";
export const SESSION_ID = "JUGL__SESSION_ID";
export const ENTITY_LINK_INVITATION = "JUGL__ENTITY_LINK_INVITATION";
export const UPDATES_AUTOMATION_DIALOG_SHOWN =
  "JUGL__UPDATES_AUTOMATION_DIALOG_SHOWN";
export const APP_THEME_KEY = "JUGL__CURRENT_THEME";
export const ENTITY_ID_KEY = "jugl:entityId";
export const NEW_ENTITY_SESSION_PARAMS = "JUGL__NEW_ENTITY_SESSION_PARAMS";
export const LAST_JOINED_ENTITY_ID_KEY = "JUGL__LAST_JOINED_ENTITY_ID";
export const ENTITY_INVITATIONS_SHOWN_KEY = "JUGL__ENTITY_INVITATIONS_SHOWN";
export const HIDE_GUEST_URL_WARNING_DIALOG_KEY =
  "JUGL__HIDE_GUEST_URL_WARNING_DIALOG";
export const SKIP_FUTURE_ALERTS_CONFIG_KEY = "JUGL__SKIP_FUTURE_ALERTS_CONFIG";
export const ANONYMOUS_SESSION_ENTITY_ID_KEY =
  "JUGL__ANONYMOUS_SESSION_ENTITY_ID";
export const ANONYMOUS_SESSION_ACTIVE_KEY =
  "JUGL__ANONYMOUS_SESSION_ACTIVE_KEY";
export const CX_TRIAL_PROCEEDED_KEY = "JUGL__CX_TRIAL_PROCEEDED";
export const CX_GOOGLE_OAUTH_PENDING_CLAIM_KEY =
  "JUGL__CX_GOOGLE_OAUTH_PENDING_CLAIM";
export const CX_BUSINESS_NAME_KEY = "JUGL__CX_BUSINESS_NAME";
export const LOGIN_FLOW_KEY = "JUGL__LOGIN_FLOW";
export const CX_SELECTED_CHANNEL_KEY = "JUGL__CX_SELECTED_CHANNEL";
export const CUSTOM_INSTRUCTIONS_BY_ENTITY_ID_KEY =
  "JUGL__CUSTOM_INSTRUCTIONS_BY_ENTITY_ID";
export const COLLECT_LEADS_TOOLTIP_SHOWN_KEY =
  "JUGL__COLLECT_LEADS_TOOLTIP_SHOWN";
// #endregion

// #region Tickets
export const CX_TICKETS_SIDEBAR_EXPANDED_KEY =
  "JUGL__CX_TICKETS_SIDEBAR_EXPANDED";
export const CX_TICKETS_SIDEBAR_MANUAL_WIDTH_KEY =
  "JUGL__CX_TICKETS_SIDEBAR_MANUAL_WIDTH";
export const CX_INBOX_SIDEBAR_PINNED_KEY = "JUGL__CX_INBOX_SIDEBAR_PINNED";
export const TICKETS_VIEW_SEARCH_QUERY_KEY = "JUGL__TICKETS_VIEW_SEARCH_QUERY";
export const TICKETS_VIEW_SORT_KEY = "JUGL__TICKETS_VIEW_SORT";
export const CRM_GMAIL_OAUTH_PENDING_REDIRECT_KEY =
  "JUGL__CRM_GMAIL_OAUTH_PENDING_REDIRECT";
// set on return from the Gmail OAuth round-trip so the inbox can toast the
// connection result once the email config has loaded
export const CRM_GMAIL_OAUTH_RESULT_PENDING_KEY =
  "JUGL__CRM_GMAIL_OAUTH_RESULT_PENDING";
// set when "Connect with Shopify" is initiated from inside Jugl (internal
// flow) so /shopify/callback can associate the OAuth callback with the
// workspace it was started from
export const SHOPIFY_CONNECT_PENDING_KEY = "JUGL__SHOPIFY_CONNECT_PENDING";
// #endregion

// #region Alert perferences
export const DISABLE_TASK_FIELD_ALERT_ID = "DISABLE_TASK_FIELD_ALERT";
export const CLOSE_CONVERSATION_ALERT_ID = "CLOSE_CONVERSATION_ALERT";
export const REOPEN_CONVERSATION_ALERT_ID = "REOPEN_CONVERSATION_ALERT";
export const RESOLVE_TICKET_ALERT_ID = "RESOLVE_TICKET_ALERT";
// #endregion

// #region Dashboard keys
export const SELECTED_DASHBOARD_ID_BY_ENTITY_ID_KEY =
  "JUGL__SELECTED_DASHBOARD_ID_BY_ENTITY_ID";
export const DASHBOARD_WIDGET_DATE_RANGE_BY_ENTITY_ID_KEY =
  "JUGL__DASHBOARD_WIDGET_DATE_RANGE_BY_ENTITY_ID";
// #endregion

// #region Tasks/templates keys
export const TASK_PREFERENCES_BY_TASK_ID_KEY =
  "JUGL__TASK_PREFERENCES_BY_TASK_ID";
export const TASK_LIST_PREFERENCES_KEY = "JUGL__TASK_LIST_PREFERENCES";
export const TEMPLATE_FOLDERS_SEARCH_QUERY_KEY =
  "JUGL__TEMPLATE_FOLDERS_SEARCH_QUERY";
export const TEMPLATE_FOLDERS_FILTER_KEY = "JUGL__TEMPLATE_FOLDER_FILTERS";
export const IS_PRIVATE_TASK_HINT_SHOWN_KEY =
  "JUGL__IS_PRIVATE_TASK_HINT_SHOWN";
export const TASK_COLLAPSED_CALENDAR_REPORTEE_PANELS_BY_ENTITY_ID_KEY =
  "TASK_COLLAPSED_CALENDAR_REPORTEE_PANELS_BY_ENTITY_ID";
export const USER_ENTITY_BOARD_MAPPING_KEY = "JUGL__USER_ENTITY_BOARD_MAPPING";
export const TASK_ATTACHMENTS_LAYOUT_KEY = "JUGL__TASK_ATTACHMENTS_LAYOUT";
export const RECENTLY_USED_TASK_TEMPLATES_KEY =
  "JUGL__RECENTLY_USED_TASK_TEMPLATES";
export const MY_TASKS_FIELD_SETTINGS_MAP_KEY =
  "JUGL__MY_TASKS_FIELD_SETTINGS_MAP";
export const ACTIVE_TIME_TRACKING_NOTES_BY_LOG_ID_KEY =
  "JUGL__ACTIVE_TIME_TRACKING_NOTES_BY_LOG_ID";
export const ANONYMOUS_SESSION_PLAN_INFO =
  "JUGL__ANONYMOUS_SESSION_PLAN_INFO_KEY";
// #endregion

// #region User settings keys
export const AVATAR_VERSION_STORAGE_KEY = "JUGL__SETTINGS_AVATAR_VERSION";
// #endregion

// #region Inventory
export const INVENTORY_TABLE_SETTINGS_KEY =
  "JUGL__INVENTORY_TABLE_SETTINGS_0.0.4";
// #endregion

// #region CRM Inbox
export const CRM_INBOX_PREFERENCES_KEY = "JUGL__CRM_INBOX_PREFERENCES";
export const VISITOR_IDENTIFIED_CONTACT_INFO_STORAGE_KEY =
  "JUGL__VISITOR_IDENTIFIED_CONTACT_INFO";
// prefix + message id; remembers whether a long email body is expanded (session)
export const CRM_EMAIL_MESSAGE_EXPANDED_KEY_PREFIX =
  "JUGL__CRM_EMAIL_MESSAGE_EXPANDED_";
// #endregion
// #region Customers
export const CUSTOMER_LIST_PREFERENCES_KEY = "JUGL__CUSTOMER_LIST_PREFERENCES";
// #endregion

// #region Modules
export const ENABLED_ENTITY_MODULES_KEY = "JUGL__ENABLED_ENTITY_MODULES";
// #endregion

// #region Spotlights/hints keys
export const DASHBOARD_SPOTLIGHT_TOUR_ID = "JUGL__DASHBOARD_SPOTLIGHT_TOUR";
export const TASK_TEMPLATES_SPOTLIGHT_TOUR_KEY =
  "JUGL__TASK_TEMPLATES_SPOTLIGHT_TOUR";
export const EDIT_TASK_FROM_TEMPLATE_SPOTLIGHT_KEY =
  "JUGL__EDIT_TASK_FROM_TEMPLATE_SPOTLIGHT";
export const MANAGE_TASK_FIELDS_HINT_DISMISSED_KEY =
  "JUGL__MANAGE_TASK_FIELDS_HINT_DISMISSED";
export const RESTRICTED_BOARDS_TAB_HINT_DISMISSED_KEY =
  "JUGL__RESTRICTED_BOARDS_TAB_HINT_DISMISSED";
export const CREATE_ORDER_FORM_SPOTLIGHT_KEY =
  "JUGL__CREATE_ORDER_FORM_SPOTLIGHT";
export const SUBMITTED_ORDER_FORM_SPOTLIGHT_KEY =
  "JUGL__SUBMITTED_ORDER_FORM_SPOTLIGHT";
export const SWITCH_BOARD_SPOTLIGHT_KEY = "JUGL__SWITCH_BOARD_SPOTLIGHT";
export const CREATE_BOARD_SPOTLIGHT_KEY = "JUGL__CREATE_BOARD_SPOTLIGHT";
export const EDIT_BOARD_SPOTLIGHT_KEY = "JUGL__EDIT_BOARD_SPOTLIGHT";
export const ORDER_FORM_PREVIEW_SPOTLIGHT_KEY =
  "JUGL__ORDER_FORM_PREVIEW_SPOTLIGHT";
// #endregion

// #region GUEST_APP

export const GUEST_APP_EXTERNAL_USER_NAME_KEY =
  "JUGL__GUEST_APP_EXTERNAL_USER_NAME";

// #region Utils
export const getStorageItem = <TItem>(
  key: string,
  storage: Storage = localStorage
): TItem | undefined => {
  const rawItem = storage.getItem(key);

  if (!rawItem) {
    return undefined;
  }

  try {
    return JSON.parse(rawItem) as TItem;
  } catch {
    return undefined;
  }
};

export const getStorageItemWithFallback = <TItem>(
  key: string,
  fallback: TItem,
  storage: Storage = localStorage
): TItem => getStorageItem<TItem>(key, storage) ?? fallback;

export const saveItemToStorage = <TItem>(
  key: string,
  item: TItem,
  storage: Storage = localStorage
) => {
  try {
    storage.setItem(key, JSON.stringify(item));
  } catch (error) {
    // oxlint-disable-next-line no-console
    console.warn(`Failed to save item to storage: ${error}`);
  }
};
// #endregion
